// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.9902 7.1416L19.8672 22L12.7334 21.999L15 11L18 11L12 5L11.5 8L6 8L8 11H11L8.7334 21.999H1.88281L4.10449 2L17.4883 2L22.0596 6.65137L21.9902 7.1416Z"}}]};

const LogoWechatWorkdocsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-wechat-workdocs-filled',
    ref,
    icon: element,
  },
));

LogoWechatWorkdocsFilledIcon.displayName = 'LogoWechatWorkdocsFilledIcon';

export default LogoWechatWorkdocsFilledIcon;
